import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';
import { User } from '@mkp/user/models';
import { Store } from '@ngrx/store';
import { selectLoggedInUser } from '@mkp/user/state-logged-in/selectors';
import { filter, map, take } from 'rxjs';

export const hasFullUserInformationGuard = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectLoggedInUser).pipe(
    filter((user) => user !== undefined),
    map((user) => hasFullInformation(user)),
    map((hasAllInfo) => hasAllInfo || router.parseUrl(AppConfig.routes.incompleteOnboarding)),
    take(1)
  );
};

export const hasFullInformation = (user: User | undefined | null): boolean =>
  !!user?.firstName && !!user?.lastName;
